import sortBy from 'lodash/sortBy';
import map from 'lodash/map';

import { OptionType } from '../../Select';

import { phoneCodes } from './phone-codes';

export const phoneCountryOptions: OptionType<string, { mask: string }>[] = [
    { value: 'RU', label: 'Россия', mask: '+7(###)###-##-##' },
    ...sortBy(
        map(phoneCodes, ({ mask, name_ru, cc: value }) => ({ value, mask, label: `${name_ru} ${mask}` })),
        ({ label }) => label,
    ),
];
